import { Lookup } from "../../../shared-components/lookup/lookup.model";
import { Student } from "../../../shared-components/student/student.model";

export class BehaviorInterventionsFilterParam {
    startDateFrom?: Date=null;
    startDateTo?: Date=null;
    endDateFrom?: Date=null;
    endDateTo?: Date=null;
    nextMeetingDateFrom?: Date=null;
    nextMeetingDateTo?: Date=null;
    interventionist?: Lookup=null;
    refferedBy?: Lookup=null;
    refferedByOther?: string=null;
    status?: Lookup=null;
    notes?: string=null;
    students: Student[] = [];
    selectedReasons?: string[] = [];
    enteredBy?: string=null;
    statusV9?: string[] = [];
}
